module.exports = __webpack_public_path__ + "img/hcml_gallery6.fa7fa2cc.jpg";